import { type CustomFieldsFieldTypeEnum, type ValueDataFragment } from 'generated/resources/graphql'

export const coerceValueFromType = (
  customValue: ValueDataFragment,
  fieldType: CustomFieldsFieldTypeEnum
) => {
  switch (fieldType) {
    case 'cents':
    case 'money':
      return customValue.centsValue ? parseInt(customValue.centsValue, 10) : 0
    case 'rating':
      return customValue.numberValue
    case 'text':
    case 'long_text':
      return customValue.longTextValue
    case 'date':
      return customValue.dateValue
    case 'checkbox':
      return customValue.booleanValue
    case 'single_choice':
      return customValue.singleChoiceValue
    case 'multiple_choice':
      return customValue.multipleChoiceValue
  }
}
